<template>
  <div>
    <AccessibilitySkipLinks />
    <LayoutHeader />
    <NuxtLoadingIndicator v-if="lowStimulusActive" />
    <UIPageLoader v-else />

    <main>
      <slot />
      <AccessibilityMenuPanel />
    </main>

    <LayoutFooter class="q-mt-xl" />
  </div>
</template>

<script setup lang="ts">
  const { getHtmlClasses, lowStimulusActive } = useBaseAccessibility()
  const localization = useBaseLocalization()
  const currentLanguage = computed(() => localization.getCurrentLanguage())

  useHead({
    htmlAttrs: {
      lang: currentLanguage.value.name,
      class: computed(() => getHtmlClasses()),
    },
    meta: [{ name: 'viewport', content: 'width=device-width, initial-scale=1' }],
  })
</script>

<style scoped lang="scss">
  main {
    min-height: 100vh;
    padding-top: var(--header-height);
  }

  .nuxt-loading-indicator {
    background: $white !important;
  }
</style>
